import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { DishWithSnapshotInfo } from 'types';

export const getDishBySnapshot = async (
  snapshotId: number
): Promise<DishWithSnapshotInfo | undefined> => {
  if (snapshotId < 1) return;
  const { data }: { data: DishWithSnapshotInfo } = await axios.get(
    `/api/dishes/snapshots/${snapshotId}`
  );
  return data as DishWithSnapshotInfo;
};

type QueryFnType = typeof getDishBySnapshot;

type UseDishesBySnapshotOptions = {
  snapshotId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useDishesBySnapshot = ({
  snapshotId,
  config,
}: UseDishesBySnapshotOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['dishes', 'snapshots', snapshotId],
    queryFn: () => getDishBySnapshot(snapshotId),
    ...config,
  });
};
